import { getState } from "../state";

export interface SearchResult {
  type: "asset" | "forecast";
  id: string;
  title: string;
  subtitle: string;
  panel: string;
}

export function search(query: string): SearchResult[] {
  if (!query || query.length < 2) return [];
  const needle = query.toLowerCase();
  const state = getState();
  const results: SearchResult[] = [];
  const seen = new Set<string>();

  for (const a of state.assets) {
    const haystack = [a.projectName, a.productName, a.name, a.brand, a.division, a.hub, a.globalEAN, a.type]
      .filter(Boolean).join(" ").toLowerCase();
    if (haystack.includes(needle) && !seen.has(a.id)) {
      seen.add(a.id);
      results.push({
        type: "asset",
        id: a.id,
        title: a.projectName || a.productName || a.name || a.id,
        subtitle: [a.brand, a.division, a.hub].filter(Boolean).join(" · "),
        panel: "dashboard",
      });
    }
    if (results.length >= 15) break;
  }

  return results;
}
